export var IRMSErrorEnum;
(function (IRMSErrorEnum) {
    IRMSErrorEnum["ERROR_DATA"] = "errorData";
    IRMSErrorEnum["RMS_HOLDING_ERROR"] = "rmsHoldingErrorData";
})(IRMSErrorEnum || (IRMSErrorEnum = {}));
